<template>
  <div>
    <date-time v-bind="{ type: this.type }" :value="interval['from']" @change="onChange" name="from"></date-time>
    <date-time v-bind="{ type: this.type }" :value="interval['to']" @change="onChange" name="to"></date-time>
  </div>
</template>

<script>
import DateTime from '../../list/search/fields/DateTime'
import { cloneDeep, isEmpty } from 'lodash'
import { isObject } from '../../../utils'

/**
 * @class DateTimeFilter
 *
 * @description This component renders the DateTime range selectors for filtering Lists
 */
export default {
  name: 'DateTimeFilter',
  components: {
    DateTime,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    name: {
      type: String,
    },
    type: {
      type: String,
      default: 'date_interval',
    },
  },
  data() {
    return {
      interval: {},
    }
  },
  computed: {
    getValue() {
      return this.interval['from'] === '' && this.interval['to'] === '' ? {} : this.interval
    },
  },
  methods: {
    onChange($evt) {
      const key = Object.keys($evt)[0]
      if (key) {
        if ($evt[key] !== '') {
          this.interval[key] = $evt[key]
        } else {
          delete this.interval[key]
        }
        this.$emit('form-item-changed', {
          name: this.name,
          value: this.getValue,
        })
        this.$forceUpdate()
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function () {
        if (isObject(this.value) && !isEmpty(this.value)) {
          this.interval = cloneDeep(this.value)
        }
      },
    },
  },
}
</script>
